export const US_MAP_CENTER = { lat: 39.8283, lng: -98.5795 };

export const DEFAULT_CENSUS_DATA_FIELDS = [
  {
    id: 'population',
    label: 'Population',
  },
  { id: 'median_household_income', label: 'Median Household Income' },
];
